import { useCallback, useEffect, useState } from 'react'
import bus from '../utils/EventBus.js'
import { ApiGateway, Stage } from '../config/config.js'
import axios from 'axios'

import {MaterialReactTable} from 'material-react-table'
import { Box, Button, Skeleton} from '@mui/material'
import Tooltip from '@mui/material/Tooltip';
import ConfirmDialog from '../form/ConfirmDialog.js'
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { getToken } from '../auth/auth.js'
import { Edit } from '@mui/icons-material'

export default function ListUsers(props = { searchFilter: undefined }) {
  const { onSelectChange, searchFilter, showFilters } = props
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [dialogTitle, setDialogTitle] = useState("Delete this User?")
  const [userToDelete, setUserToDelete] = useState("")  
  const [userRows, setUserRows] = useState([])  
  const [searching, setSearching] = useState(false)
  

  const getUserList = useCallback(async (_listRoleId) => {
    const search = searchFilter ?? {
      isActive: true,
      roleId: _listRoleId ?? 0
    }
    const roleId = search.roleId
    if (roleId > 0) {
      // props.startLoading()
      setSearching(true)
      const token = await getToken()      
      
      const basePath = `${ApiGateway.user}/search`
      const options = {
        headers: {        
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token.idToken}`
        }
      }
      try {
        const response = await axios.post(basePath, search, options )
        
        setUserRows(response.data)
      } catch (error) {
        console.error(error)
      }
    }
    setSearching(false)
    // props.stopLoading()
    return
  }, [searchFilter])

  useEffect(() => {
    if (searchFilter !== undefined) {
      getUserList()
    }
  },
    [getUserList, searchFilter]
  )


  const hideDialog = () => {
    setConfirmDialog(false)
  }

  const getFilterTextFieldProps = (id) => {
    const p = id.split('')[0]
    return { 
        onBlur: (event) => { 
          if (event.target.value === '') {
            const isP = searchParams.get(p)
            if (isP) {
              setSearchParams((s) => {
                s.delete(p)
                return s
              })
            }
          } else {
            setSearchParams((s) => {
              s.set(p, `${event.target.value}`)
              return s
            })
          }
          
        },
      }
  }

  const userColumns = [
    {
      accessorKey: 'koId',
      header: 'KO ID',
      size: 125,
      grow: false,
      editable: false,
      filterVariant: 'text',
      muiFilterTextFieldProps: getFilterTextFieldProps('koId'),
      Cell: ({row}) => (
        <Tooltip arrow placement="right" title="Edit">
        <Link to={ "/users/edit/" + row.original.koId }>
          {row.original.koId}
        </Link>
        </Tooltip>
      )
    },
    {
      accessorKey: 'lastName',
      header: 'Last Name',
      size: 175,
      grow: false,
      editable: false,
      filterVariant: 'text',
      muiFilterTextFieldProps: getFilterTextFieldProps('lastName')
    },
    {
      accessorKey: 'firstName',
      header: 'First Name',
      size: 175,
      grow: false,
      editable: false,
      filterVariant: 'text',
      muiFilterTextFieldProps: getFilterTextFieldProps('firstName')
    },
    {
      accessorKey: 'email',
      header: 'Email',
      size: 200,
      grow: true,
      editable: false,
      muiFilterTextFieldProps: getFilterTextFieldProps('email')
    },
    {
      accessorKey: 'active',
      accessorFn: ((row) => {
        if ([true, null].includes(row.isActive)) {
          return 'Y'
        } else {
          return 'N'
        }
      }),
      header: 'Active?',
      size: 100,
      grow: false,
      editable: false,
      muiFilterTextFieldProps: getFilterTextFieldProps('active')
    },
    // {
    //   accessorKey: 'actions',
    //   header: 'Actions',
    //   columnDefType: 'display', 
    //   size: 10,
    //   Cell: ({ row }) => (
    //     <Box sx={{ display: 'flex', gap: '0rem' }}>
    //     <Tooltip arrow placement="left" title="Edit">
    //       <Link to={ "/users/edit/" + row.original.koId }>
    //       <Typography variant='caption'>edit</Typography>
    //       {/* <IconButton size='small'>
    //         <EditIcon/>
    //       </IconButton> */}
    //       </Link>
    //     </Tooltip>
    //     </Box>
    //   )
    // }
  ]

  const deleteUser = async(selectedKoId) => {
    hideDialog()
    setSearching(true)
    bus.emit(Event.ALERT, { text: "Deleting Users...", style: "info", duration: 2000 })

    const options = {
      headers: {
        'x-api-key': ApiGateway.apiKey,
        'Content-Type': 'application/json',
        'Authorization': ApiGateway.auth
      }
    }
    const path = `${ApiGateway.employee}/${selectedKoId}`
    await axios.delete(path, options)
    await getUserList()
    setSearching(false)
    bus.emit(Event.ALERT, { text: "User deleted", style: "success", duration: 2000 })
  }

  const [columnFilters, setColumnFilters] = useState([
              { id: 'koId', value: searchParams.get('k') ?? ''},
              { id: 'lastName', value: searchParams.get('l') ?? ''},
              { id: 'firstName', value: searchParams.get('f') ?? ''},
              { id: 'email', value: searchParams.get('e') ?? ''},
              { id: 'active', value: searchParams.get('a') ?? 'Y'}
            ])
  const [rowSelection, setRowSelection] = useState({})
  useEffect(() => {
    if (onSelectChange) {
      onSelectChange(rowSelection)
    }
  }, [onSelectChange, rowSelection])

  return (
    <>
      <ConfirmDialog title={dialogTitle} text="The record will be permanently deleted" open={confirmDialog} hideDialog={hideDialog} handleConfirm={()=>deleteUser(userToDelete)} yesLabel="Delete" noLabel="Keep"/>        
        { rowSelection && Object.entries(rowSelection).some(([k,v]) => !!v) &&
        <Box alignItems={'start'} m={'0 0 3px 0'}>
          <Button variant='outlined' onClick={() => {
            const sels = Object.entries(rowSelection).reduce((p, [k,v]) => {
              if (!!v) return [...p, k]
              return p
            }, [])
            navigate("/users/edit/selected", { state: { selected: sels}})
          }} startIcon={<Edit />}>Edit Selected</Button>
        </Box>
        }
        { searching && 
          <Skeleton animation={'pulse'} width={'100%'} height={300}/>
        }
        {!searching && 
        <MaterialReactTable
          layoutMode='grid'
          columns={userColumns}
          data={userRows}
          enableColumnActions={false}
          enableColumnFilters={showFilters}
          enableFilterMatchHighlighting={false}
          onColumnFiltersChange={(updater) => {
            const newFilters = updater instanceof Function ? updater(columnFilters) : updater;
            const removed = columnFilters.filter(c => newFilters.findIndex(n => n.id === c.id) === -1)
            if (removed.length) {
              setSearchParams((s) => {
                  removed.forEach(r => {
                    let p = r.id.split('')[0]
                    s.delete(p)
                  })
                  return s
              })
            }
            setColumnFilters(newFilters);
          }}
          enableRowSelection={true}//{Stage !== 'prod'}
          getRowId={(originalRow) => originalRow.koId}
          onRowSelectionChange={setRowSelection}
          state={{ columnFilters: columnFilters, rowSelection: rowSelection }}
          initialState={{
            showColumnFilters: true,
            // columnFilters: [
            //   { id: 'koId', value: searchParams.get('k') ?? ''},
            //   { id: 'lastName', value: searchParams.get('l') ?? ''},
            //   { id: 'firstName', value: searchParams.get('f') ?? ''},
            //   { id: 'email', value: searchParams.get('e') ?? ''},
            //   { id: 'active', value: searchParams.get('a') ?? 'Y'}
            // ]
          }}
          enablePagination={true}
          enableSorting={true}
          enableBottomToolbar={true}
          enableEditing={false}
          
          muiTableContainerProps={{ sx: { minHeight: 300 } }}
          renderTopToolbar={false}
        />
        }
    </>
  )
}